import { Menu, MenuItem, Stack, styled } from '@mui/material'
import { MouseEvent, ReactNode, useState } from 'react'
import { TinyButton, TinyButtonProps } from './TinyButton'
import { tokens } from 'ComponentLibrary/style-dictionary/output'
import { CaretDownIcon, CaretUpIcon } from '@phosphor-icons/react'
import { Typography } from '../../text'

export type Option = {
    title: string
    callback: () => void
    icon?: ReactNode
}

type TinyButtonWithOptionsProps = {
    options: Option[]
} & Omit<TinyButtonProps, 'onClick'>

export function TinyButtonWithOptions({ options, ...tinyButtonProps }: TinyButtonWithOptionsProps) {
    const [anchorEl, setAnchorEl] = useState<undefined | HTMLElement>()

    const onClick = (event: MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation()
        setAnchorEl(event.currentTarget)
    }

    const onClose = (event: MouseEvent<HTMLButtonElement>) => {
        event.stopPropagation()
        setAnchorEl(undefined)
    }

    return (
        <>
            <TinyButton onClick={onClick} {...tinyButtonProps} rightIcon={!anchorEl ? <CaretDownIcon /> : <CaretUpIcon />} />
            <Menu anchorEl={anchorEl} open={!!anchorEl} onClose={onClose}>
                {options.map((option) => (
                    <StyledMenuItem
                        key={`menu-item-${option.title}`}
                        onClick={(event) => {
                            event.stopPropagation()
                            option.callback()
                            setAnchorEl(undefined)
                        }}
                        disableRipple
                    >
                        <Stack direction="row" gap={tokens.SizingSpacing075} alignItems="center">
                            {option.icon}
                            <Typography variant="textM">{option.title}</Typography>
                        </Stack>
                    </StyledMenuItem>
                ))}
            </Menu>
        </>
    )
}

const StyledMenuItem = styled(MenuItem)(() => ({
    minHeight: 'auto',
    padding: '9px 16px',
}))
